module.exports = __webpack_public_path__ + "static/media/logoMinotaNegro.c4c6a661.png";